export default __webpack_public_path__ + "static/media/talent.5fa18587.svg";